import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CaretDownIcon, XSmallCircleColorIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
import { IconButton } from '../button';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from '../drawer';
import { SelectIcon } from './SelectIcon';
import { selectTriggerVariants } from './SelectTrigger';
import { SelectValue } from './SelectValue';
import { type SelectPropsBase, type SelectUIProps } from './type';
export const SelectOnDrawerLayout = <T extends string = string,>(props: SelectPropsBase<T> & SelectUIProps & {
  className?: string;
  hasDrawerHandle?: boolean;
} & {
  children?: React.ReactNode;
}) => {
  return <Drawer open={props.isOpen} onOpenChange={open => {
    if (!open) {
      props.close();
    }
  }} data-sentry-element="Drawer" data-sentry-component="SelectOnDrawerLayout" data-sentry-source-file="SelectOnDrawerLayout.tsx">
      {/* 데스크탑 Select 와 동일하게 트리거는 토글이어야 한다(다시 누르면 닫힘). */}
      <DrawerTrigger asChild onClick={() => props.isOpen ? props.close() : props.open()} tabIndex={0} data-sentry-element="DrawerTrigger" data-sentry-source-file="SelectOnDrawerLayout.tsx">
        {props.trigger ?? <div className={selectTriggerVariants({
        intent: props.intent,
        error: props.error,
        disabled: props.disabled,
        open: props.isOpen,
        className: cn('flex items-center justify-between', props.className)
      })}>
            <SelectValue placeholder={props.placeholder}>
              {props.renderedValue}
            </SelectValue>
            <SelectIcon open={props.isOpen}>
              <CaretDownIcon size="md" fill={ICON_COLOR.default} />
            </SelectIcon>
          </div>}
      </DrawerTrigger>
      <DrawerContent className="max-h-[50dvh] w-full rounded-t-md px-md focus:!shadow-none" hasDim={true} hasDrawerHandle={!!props.hasDrawerHandle} onDimClick={props.close} data-sentry-element="DrawerContent" data-sentry-source-file="SelectOnDrawerLayout.tsx">
        {props.title && <DrawerHeader className="flex items-center justify-between pb-xs pt-md text-heading-md-bold">
            <DrawerTitle>{props.title}</DrawerTitle>
            <IconButton variant={'transparent'} intent="neutral" size="sm" onClick={props.close}>
              <XSmallCircleColorIcon size="md" />
            </IconButton>
          </DrawerHeader>}
        <div className={'h-full overflow-y-scroll pb-lg pt-xs'} style={!props.showScrollbar ? {
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        WebkitOverflowScrolling: 'auto'
      } : undefined}>
          {props.children}
        </div>
      </DrawerContent>
    </Drawer>;
};